import { render, staticRenderFns } from "./ElVideoPopupV3.vue?vue&type=template&id=b351fe84"
import script from "./ElVideoPopupV3.vue?vue&type=script&lang=js"
export * from "./ElVideoPopupV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports